import React, { useState, useEffect, useContext } from "react";
import { Row, Col, Button, Form, OverlayTrigger, Popover } from "react-bootstrap";
import { Link } from "react-router-dom";
import BackButton from "../BackButton";
import NextButton from "../NextButton";
import SkipButton from "../SkipButton";
import getNextPage from "../getNextPage";
import CustomFormCheck from "utils/CustomFormCheck";
import jsDig from "utils/jsDig";
import { RouterContext } from "../Onboarding";

export default function ShopifyAuthenticate(props) {
  const route = useContext(RouterContext);

  const nextPage = getNextPage(props.onboarding_progress);

  useEffect(() => {
    window.localStorage.setItem("routerHistory", JSON.stringify([...route.get]));
  }, [route.get]);

  props.pageLocator();

  const [validated, setValidated] = useState(false);

  useEffect(() => {
    const form = document.getElementById("onboarding-form");
    if (form.checkValidity() === true) {
      setValidated(true);
    } else {
      setValidated(false);
    }
  });

  const [urlProvided, setUrlProvided] = useState(false);

  const [urlCopied, setUrlCopied] = useState(false);

  const getFullShopifyUrl = (url) => {
    if (url && url != "") {
      if (url.includes(".myshopify.com")) {
        return url;
      } else {
        return url + ".myshopify.com";
      }
    } else {
      return false;
    }
  };

  const copyAuthUrl = () => {
    let authUrl = "";
    if (getFullShopifyUrl(props.shopifyUrl) == false) {
      return false;
    }
    const paramsObject = {
      shopify_url: getFullShopifyUrl(props.shopifyUrl),
    };
    $.ajax({
      type: "POST",
      url: "/datapulse/shopify-authenticate",
      dataType: "json",
      async: false,
      contentType: "application/json",
      data: JSON.stringify(paramsObject),
      success: (data, success, xhr) => {
        authUrl = data.permission_url;
      },
    });

    /* Copy the text inside the text field */
    navigator.clipboard.writeText(authUrl);
    setUrlCopied(true);
  };

  const authenticateFunction = () => {
    if (getFullShopifyUrl(props.shopifyUrl) == false) {
      return false;
    }
    const paramsObject = {
      shopify_url: getFullShopifyUrl(props.shopifyUrl),
    };
    $.ajax({
      type: "POST",
      url: "/datapulse/shopify-authenticate",
      dataType: "json",
      async: false,
      contentType: "application/json",
      data: JSON.stringify(paramsObject),
      success: (data, success, xhr) => {
        window.open(data.permission_url, "_blank");
      },
    });
  };

  let shopifyIcon = require("images/logos/shopify-icon.png");
  shopifyIcon = <img className="shopify-icon" style={{ width: "15px", position: "relative", top: "-2px", left: "5px" }} src={`/datapulse${shopifyIcon}`} />;
  const authenticateButton = (
    <Button
      className="mt-2 mb-2 py-1 px-4 mx-2 text-center"
      style={{minWidth: "200px"}}
      variant="success"
      disabled={getFullShopifyUrl(props.shopifyUrl) == false ? true : false}
      onClick={authenticateFunction}>
      Authenticate
      {shopifyIcon}
    </Button>
  );

  const copyButton = (
    <Button
      className="mt-2 mb-2 py-1 px-4 mx-2 text-center"
      style={{minWidth: "200px"}}
      variant="info"
      disabled={getFullShopifyUrl(props.shopifyUrl) == false ? true : false}
      onClick={copyAuthUrl}>
      Copy install link&nbsp;&nbsp;
      {urlCopied ? <i className="fas fa-check"></i> : <i className="fa fa-clipboard" aria-hidden="true"></i>}
    </Button>
  );

  return (
    <>
      <input hidden name="current_onboarding_page" value={window.location.href} readOnly />
      <Row className=" px-4 mb-3 pb-3 justify-content-center">
        <Col lg={7}>
          <div>
            <p className="pb-3 f28 visby-bold primary text-center">Grant DataPulse Access to Shopify</p>
          </div>
          <div>
            <p className=" f14 nunito-regular primary text-left">
              Now you will install the DataPulse Bridge to the client's Shopify store. This will allow DataPulse to connect and pull metrics and display them in the dashboards.
            </p>
          </div>
          <div>
            <p className="text-center f22 pt-3">{getFullShopifyUrl(props.shopifyUrl)}</p>
          </div>
        </Col>
      </Row>
      <Row className="mb-5 justify-content-center">
        <Col xl={8} lg={10} style={{ maxWidth: "100%" }}>
          <Row>
            <Col className="flex-wrap grey-box" style={{ backgroundColor: "#E1E1E1"}}>
              <div>
                <p className="f14 light-primary text-left">
                  Authenticate your account with one of the two methods below. The green authenticate button will attempt to authenticate automatically,
                  or click the blue button to copy the URL (then paste in your browser) to authenticate manually.
                </p>
              </div>
              <div className="text-center">
                {authenticateButton}
                {copyButton}
              </div>
            </Col>
          </Row>
        </Col>
      </Row>

      <Row className="pt-3 justify-content-center">
        <Col>
          <div className="navButtonRow">
            <BackButton />
            <SkipButton btnText={`Skip for now`} nextPage={nextPage.url} />
            <NextButton
              validated={validated}
              btnText={`Next`}
              nextPage={nextPage.url}
              invalidText={`We need more information on this page before you continue.`}
              submitForm={props.submitForm}
            />
          </div>
        </Col>
      </Row>
    </>
  );
}
